import React from 'react'

import { Icon, Search, TextInput } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, object, string } from 'prop-types'

function FilterSearchInput({
  id,
  value,
  onChange,
  placeholder,
  inputRef = null,
}) {
  const handleChange = (event) => onChange(event.target.value)

  return (
    <TextInput
      id={id}
      isPilot
      size="medium"
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      leadIcon={<Icon notSpaced svgComponent={Search} color="dark" />}
      textInputClassName="filter-wrapper__search-input"
      wrapperClassName="filter-wrapper__search"
      innerRef={inputRef}
    />
  )
}

FilterSearchInput.propTypes = {
  id: string.isRequired,
  value: string.isRequired,
  onChange: func.isRequired,
  placeholder: string.isRequired,
  inputRef: object,
}

export default FilterSearchInput
